module.exports = __webpack_public_path__ + "media/application/images/cost-recovery-bg-fa195445a547a2da802784f10cffe730.png";